import type { Language, Department } from './types';

export interface Translations {
  appName: string;
  appSubtitle: string;
  greeting: string;
  dashboardSubtitle: string;
  newQuiz: string;
  recentPractices: string;
  noRecentPractices: string;
  navWilayas: string;
  navLevels: string;
  navModules: string;
  totalBankQuestions: string;
  collapseSidebar: string;
  expandSidebar: string;
  jumpToQuestion: string;
  userRole: string;
  deleteSession: string;
  clearAllSessions: string;
  chooseLessonMode: string;
  chooseLessonModeDesc: string;
  openTheoryStudio: string;
  openTheoryStudioDesc: string;
  openQuizMode: string;
  openQuizModeDesc: string;
  drawPen: string;
  highlighter: string;
  addNote: string;
  eraser: string;
  clearDrawing: string;
  savePdf: string;
  openInOfficialPdfReader: string;
  officialPdfReaderTooltip: string;
  examYearsLabel: string;
  exportingPdf: string;
  pdfExportSuccess: string;
  pdfExportError: string;
  startPracticeFromLesson: string;
  drawingColor: string;
  strokeSize: string;
  typeNotePlaceholder: string;
  deleteNote: string;
  selectWilaya: string;
  selectWilayaDesc: string;
  searchWilayaPlaceholder: string;
  allWilayas: string;
  selectLevel: string;
  selectLevelDesc: string;
  textHighlight: string;
  removeHighlight: string;
  highlightInstruction: string;
  studyTools: string;
  readingMode: string;
  textHighlightMode: string;
  facultyLabel: string;
  selectSubject: string;
  selectSubjectDesc: string;
  selectLesson: string;
  selectLessonDesc: string;
  allQuestionsOfSubject: string;
  questionsCount: string;
  questionSingular: string;
  noSubjectsFound: string;
  noLessonsFound: string;
  changeStep: string;
  theoryTitle: string;
  theoryTooltip: string;
  theoryClose: string;
  fontSmaller: string;
  fontLarger: string;
  loadingData: string;
  loadingQuestions: string;
  loadingErrorTitle: string;
  loadingErrorDesc: string;
  retry: string;
  backToWizard: string;
  questionOfTotal: string;
  singleChoiceOnly: string;
  chooseNAnswers: string;
  validate: string;
  previous: string;
  next: string;
  finish: string;
  explanation: string;
  incorrectAnswer: string;
  correctAnswer: string;
  theCorrectAnswer: string;
  session: string;
  chapter: string;
  lesson: string;
  allBadge: string;
  scoreTitle: string;
  scoreCorrect: string;
  scoreWrong: string;
  scoreSkipped: string;
  encouragementGreat: string;
  encouragementGood: string;
  encouragementNeedsWork: string;
  retryInOrder: string;
  retryShuffled: string;
  retryWrongOnly: string;
  backToLessons: string;
  themeLight: string;
  themeCream: string;
  themeDark: string;
  years: Record<Department, string>;
  mindmapMaker: string;
  mindmapMakerDesc: string;
  mindmapNew: string;
  mindmapAddNode: string;
  mindmapConnect: string;
  mindmapDeleteNode: string;
  mindmapDeleteEdge: string;
  mindmapShape: string;
  mindmapColor: string;
  mindmapUploadImage: string;
  mindmapImageUrl: string;
  mindmapRemoveImage: string;
  mindmapConnectorType: string;
  mindmapExportImage: string;
  mindmapExportPdf: string;
  mindmapExportJson: string;
  mindmapImportJson: string;
  mindmapTemplates: string;
  mindmapSave: string;
  mindmapSaved: string;
}

export const translations: Record<Language, Translations> = {
  ar: {
    appName: 'الدروس والامتحانات الطبية',
    appSubtitle: 'منصة دراسة الدروس والتدريب على الامتحانات الطبية',
    greeting: 'مرحباً بك، دكتور',
    dashboardSubtitle: 'ماذا تريد أن تراجع وتتدرب عليه اليوم؟',
    newQuiz: 'تمرين جديد',
    recentPractices: 'التمارين الأخيرة',
    noRecentPractices: 'لا توجد تمارين سابقة بعد',
    navWilayas: 'الولايات ومراكز الامتحانات',
    navLevels: 'المستويات والسنوات',
    navModules: 'المواد والوحدات',
    totalBankQuestions: 'إجمالي الأسئلة الطبية',
    collapseSidebar: 'طي القائمة الجانبية',
    expandSidebar: 'إظهار القائمة الجانبية',
    jumpToQuestion: 'الانتقال إلى سؤال',
    userRole: 'طالب(ة) طب',
    deleteSession: 'حذف الجلسة',
    clearAllSessions: 'مسح السجل',
    chooseLessonMode: 'كيف ترغب في بدء الدراسة؟',
    chooseLessonModeDesc: 'اختر بين قراءة ومراجعة الدرس النظري أو التدرب المباشر على الأسئلة:',
    openTheoryStudio: 'الدرس النظري (شرح وملاحظات)',
    openTheoryStudioDesc: 'قراءة الدرس كاملاً، الرسم والتلوين، كتابة الملاحظات وحفظه كـ PDF',
    openQuizMode: 'أسئلة الامتحانات (QCM)',
    openQuizModeDesc: 'بدء التدرب فوراً على أسئلة الامتحانات مع التصحيح التلقائي',
    drawPen: 'قلم رسم',
    highlighter: 'تلوين وتحديد',
    addNote: 'إضافة ملاحظة',
    eraser: 'ممحاة',
    clearDrawing: 'مسح الرسومات',
    savePdf: 'تنزيل PDF',
    openInOfficialPdfReader: 'فتح في قارئ PDF الرسمي',
    officialPdfReaderTooltip: 'فتح المستند مباشرة في عارض PDF الرسمي للنظام أو المتصفح',
    examYearsLabel: 'السنوات:',
    exportingPdf: 'جاري تجهيز PDF...',
    pdfExportSuccess: 'تم تجهيز ملف الـ PDF بنجاح!',
    pdfExportError: 'حدث خطأ أثناء تصدير PDF، يرجى المحاولة ثانية',
    startPracticeFromLesson: 'بدء حل الأسئلة',
    drawingColor: 'اللون',
    strokeSize: 'حجم الخط',
    typeNotePlaceholder: 'اكتب ملاحظتك الطبية هنا...',
    deleteNote: 'حذف الملاحظة',
    selectWilaya: 'اختر الولاية',
    selectWilayaDesc: 'حدد مصدر الأسئلة والامتحانات حسب الولاية أو تصفح الكل',
    searchWilayaPlaceholder: 'ابحث عن ولاية أو مدينة...',
    allWilayas: 'كل الولايات',
    selectLevel: 'المستوى الدراسي',
    selectLevelDesc: 'اختر الكلية والسنة الدراسية المناسبة',
    textHighlight: 'تلوين النص المحدد',
    removeHighlight: 'إزالة التلوين',
    highlightInstruction: 'حدد أي كلمة لتلوينها بأي لون',
    studyTools: 'أدوات الدراسة والملاحظات',
    readingMode: 'وضع القراءة',
    textHighlightMode: 'تلوين الكلمات',
    facultyLabel: 'الكلية',
    selectSubject: 'اختر المادة',
    selectSubjectDesc: 'اختر المادة الطبية التي ترغب في التدرب عليها',
    selectLesson: 'اختر الدرس',
    selectLessonDesc: 'اختر درساً محدداً أو تدرب على جميع أسئلة المادة',
    allQuestionsOfSubject: 'كل أسئلة المادة',
    questionsCount: 'سؤال',
    questionSingular: 'سؤال',
    noSubjectsFound: 'لا توجد مواد مسجلة لهذا المستوى حالياً',
    noLessonsFound: 'لا توجد دروس أو أسئلة متاحة في هذه المادة',
    changeStep: 'تغيير الاختيار السابق',
    theoryTitle: 'الدرس النظري',
    theoryTooltip: 'عرض الدرس النظري',
    theoryClose: 'إغلاق الدرس',
    fontSmaller: 'تصغير الخط',
    fontLarger: 'تكبير الخط',
    loadingData: 'جاري تحميل البيانات...',
    loadingQuestions: 'جاري جلب أسئلة الامتحانات...',
    loadingErrorTitle: 'تعذر تحميل البيانات',
    loadingErrorDesc: 'حدث خطأ أثناء الاتصال بقاعدة البيانات. يرجى التحقق من الاتصال والمحاولة مجدداً.',
    retry: 'إعادة المحاولة',
    backToWizard: 'لوحة التحكم',
    questionOfTotal: 'سؤال {current} من {total}',
    singleChoiceOnly: 'إجابة واحدة فقط',
    chooseNAnswers: 'اختر {n} إجابات',
    validate: 'تأكيد الإجابة',
    previous: 'السابق',
    next: 'التالي',
    finish: 'إنهاء الاختبار',
    explanation: 'الشرح',
    incorrectAnswer: 'إجابة خاطئة',
    correctAnswer: 'إجابة صحيحة',
    theCorrectAnswer: 'الإجابة الصحيحة',
    session: 'دورة',
    chapter: 'المحور',
    lesson: 'الدرس',
    allBadge: 'الكل',
    scoreTitle: 'نتيجة الاختبار',
    scoreCorrect: 'صحيحة',
    scoreWrong: 'خاطئة',
    scoreSkipped: 'بدون إجابة',
    encouragementGreat: 'ممتاز! تمكن استثنائي من المفاهيم.',
    encouragementGood: 'عمل جيد! استمر في المراجعة لتعزيز الفهم.',
    encouragementNeedsWork: 'فرصة ممتازة للمراجعة والتركيز على الأسئلة الخاطئة.',
    retryInOrder: 'إعادة بالترتيب الأصلي',
    retryShuffled: 'إعادة بترتيب عشوائي',
    retryWrongOnly: 'إعادة الأسئلة الخاطئة فقط',
    backToLessons: 'العودة لقائمة الدروس',
    themeLight: 'فاتح',
    themeCream: 'دافئ',
    themeDark: 'داكن',
    years: {
      first: 'السنة الأولى',
      second: 'السنة الثانية',
      third: 'السنة الثالثة',
      fourth: 'السنة الرابعة',
      fifth: 'السنة الخامسة',
      sixth: 'السنة السادسة',
    },
    mindmapMaker: 'صانع الخرائط الذهنية',
    mindmapMakerDesc: 'بناء وتصميم خرائط ذهنية سريرية تفاعلية يدوياً بربط العقد والأسهم والصور',
    mindmapNew: 'خريطة جديدة',
    mindmapAddNode: 'إضافة عقدة',
    mindmapConnect: 'ربط بسهم',
    mindmapDeleteNode: 'حذف العقدة',
    mindmapDeleteEdge: 'حذف السهم',
    mindmapShape: 'شكل العقدة',
    mindmapColor: 'اللون',
    mindmapUploadImage: 'رفع صورة',
    mindmapImageUrl: 'رابط صورة',
    mindmapRemoveImage: 'إزالة الصورة',
    mindmapConnectorType: 'نوع السهم',
    mindmapExportImage: 'تصدير صورة PNG',
    mindmapExportPdf: 'تصدير PDF',
    mindmapExportJson: 'نسخ احتياطي JSON',
    mindmapImportJson: 'استيراد خريطة',
    mindmapTemplates: 'نماذج جاهزة',
    mindmapSave: 'حفظ الخريطة',
    mindmapSaved: 'تم الحفظ تلقائياً',
  },
  fr: {
    appName: 'MedQCM',
    appSubtitle: "Plateforme d'entraînement aux examens médicaux",
    greeting: 'Bienvenue, Docteur',
    dashboardSubtitle: "Que souhaitez-vous réviser et pratiquer aujourd'hui ?",
    newQuiz: 'Nouveau QCM',
    recentPractices: 'Séances récentes',
    noRecentPractices: 'Aucune séance récente',
    navWilayas: 'Wilayas & Centres',
    navLevels: 'Niveaux & Années',
    navModules: 'Modules & Matières',
    totalBankQuestions: 'Total des questions d’examen',
    collapseSidebar: 'Réduire le menu',
    expandSidebar: 'Développer le menu',
    jumpToQuestion: 'Aller à la question',
    userRole: 'Étudiant(e) en Médecine',
    deleteSession: 'Supprimer la séance',
    clearAllSessions: 'Effacer l’historique',
    chooseLessonMode: 'Mode d’apprentissage',
    chooseLessonModeDesc: 'Choisissez ce que vous souhaitez faire pour ce cours :',
    openTheoryStudio: 'Cours théorique complet',
    openTheoryStudioDesc: 'Lecture, dessin et surlignage, notes personnelles et export PDF',
    openQuizMode: "Questions d'examen (QCM)",
    openQuizModeDesc: 'S’entraîner aux questions d’examen avec correction immédiate',
    drawPen: 'Stylo',
    highlighter: 'Surligneur',
    addNote: 'Ajouter une note',
    eraser: 'Gomme',
    clearDrawing: 'Effacer les tracés',
    savePdf: 'Télécharger PDF',
    openInOfficialPdfReader: 'Ouvrir dans le lecteur PDF officiel',
    officialPdfReaderTooltip: 'Ouvrir dans le visualiseur PDF natif du système ou du navigateur',
    examYearsLabel: 'Années :',
    exportingPdf: 'Génération du PDF...',
    pdfExportSuccess: 'PDF généré avec succès !',
    pdfExportError: 'Erreur lors de la création du PDF',
    startPracticeFromLesson: 'Passer aux QCMs',
    drawingColor: 'Couleur',
    strokeSize: 'Épaisseur',
    typeNotePlaceholder: 'Note médicale personnelle...',
    deleteNote: 'Supprimer la note',
    selectWilaya: 'Sélectionnez la Wilaya',
    selectWilayaDesc: 'Choisissez la source des examens par faculté/wilaya ou parcourez tout',
    searchWilayaPlaceholder: 'Rechercher une wilaya...',
    allWilayas: 'Toutes les wilayas',
    selectLevel: 'Niveau & Cursus',
    selectLevelDesc: 'Choisissez votre faculté et année universitaire',
    textHighlight: 'Surligner le texte',
    removeHighlight: 'Effacer le surlignage',
    highlightInstruction: 'Sélectionnez un mot pour le surligner',
    studyTools: 'Outils d’étude et notes',
    readingMode: 'Mode lecture',
    textHighlightMode: 'Surlignage de mots',
    facultyLabel: 'Faculté',
    selectSubject: 'Choisissez la Matière',
    selectSubjectDesc: 'Sélectionnez le module à réviser',
    selectLesson: 'Choisissez le Cours',
    selectLessonDesc: 'Révisez un cours précis ou l’ensemble des questions de la matière',
    allQuestionsOfSubject: 'Toutes les questions',
    questionsCount: 'QCMs',
    questionSingular: 'QCM',
    noSubjectsFound: 'Aucune matière trouvée pour cette année',
    noLessonsFound: 'Aucun cours ou question disponible pour ce module',
    changeStep: "Modifier l'étape précédente",
    theoryTitle: 'Cours',
    theoryTooltip: 'Ouvrir le cours théorique',
    theoryClose: 'Fermer le cours',
    fontSmaller: 'Diminuer la police',
    fontLarger: 'Agrandir la police',
    loadingData: 'Chargement des données en cours...',
    loadingQuestions: 'Chargement des QCMs...',
    loadingErrorTitle: 'Erreur de chargement',
    loadingErrorDesc: 'Impossible de contacter la base de données. Veuillez réessayer.',
    retry: 'Réessayer',
    backToWizard: 'Tableau de bord',
    questionOfTotal: 'Question {current} sur {total}',
    singleChoiceOnly: 'Choix unique',
    chooseNAnswers: 'Choisir {n} réponses',
    validate: 'Valider',
    previous: 'Précédent',
    next: 'Suivant',
    finish: 'Terminer',
    explanation: 'Explication',
    incorrectAnswer: 'Réponse incorrecte',
    correctAnswer: 'Bonne réponse',
    theCorrectAnswer: 'La bonne réponse',
    session: 'Session',
    chapter: 'Chapitre',
    lesson: 'Cours',
    allBadge: 'Tout',
    scoreTitle: 'Résultat du Quiz',
    scoreCorrect: 'Correctes',
    scoreWrong: 'Erreurs',
    scoreSkipped: 'Passées',
    encouragementGreat: 'Excellent ! Maîtrise solide du sujet.',
    encouragementGood: 'Bon travail ! Continuez les révisions régulières.',
    encouragementNeedsWork: 'Revoyez les cours et réessayez les questions manquées.',
    retryInOrder: 'Recommencer dans l’ordre',
    retryShuffled: 'Recommencer mélangé',
    retryWrongOnly: 'Revoir uniquement mes erreurs',
    backToLessons: 'Retour aux cours',
    themeLight: 'Clair',
    themeCream: 'Crème',
    themeDark: 'Sombre',
    years: {
      first: '1ère année',
      second: '2ème année',
      third: '3ème année',
      fourth: '4ème année',
      fifth: '5ème année',
      sixth: '6ème année',
    },
    mindmapMaker: 'Mindmap Maker',
    mindmapMakerDesc: 'Créez et organisez vos cartes mentales médicales : nœuds, flèches personnalisées et images.',
    mindmapNew: 'Nouvelle carte',
    mindmapAddNode: 'Ajouter un nœud',
    mindmapConnect: 'Relier par flèche',
    mindmapDeleteNode: 'Supprimer le nœud',
    mindmapDeleteEdge: 'Supprimer la liaison',
    mindmapShape: 'Forme du nœud',
    mindmapColor: 'Couleur',
    mindmapUploadImage: 'Importer une image',
    mindmapImageUrl: 'URL de l’image',
    mindmapRemoveImage: 'Supprimer l’image',
    mindmapConnectorType: 'Type de liaison',
    mindmapExportImage: 'Exporter en image PNG',
    mindmapExportPdf: 'Exporter en PDF',
    mindmapExportJson: 'Sauvegarder JSON',
    mindmapImportJson: 'Importer JSON',
    mindmapTemplates: 'Modèles cliniques',
    mindmapSave: 'Enregistrer',
    mindmapSaved: 'Enregistré automatiquement',
  },
  en: {
    appName: 'MedQCM',
    appSubtitle: 'Medical student clinical lectures and exam practice',
    greeting: 'Welcome, Doctor',
    dashboardSubtitle: 'What would you like to review and practice today?',
    newQuiz: 'New Practice',
    recentPractices: 'Recent sessions',
    noRecentPractices: 'No recent practice sessions yet',
    navWilayas: 'Wilayas & Faculties',
    navLevels: 'Years & Curriculum',
    navModules: 'Modules & Subjects',
    totalBankQuestions: 'Total Exam Questions',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    jumpToQuestion: 'Jump to question',
    userRole: 'Medical Student',
    deleteSession: 'Delete session',
    clearAllSessions: 'Clear history',
    chooseLessonMode: 'Choose Study Mode',
    chooseLessonModeDesc: 'Select how you want to study this topic:',
    openTheoryStudio: 'Theory Lecture & Notes',
    openTheoryStudioDesc: 'Complete lecture notes with drawing, highlighting, sticky notes & PDF export',
    openQuizMode: 'Exam Questions (MCQs)',
    openQuizModeDesc: 'Practice exam questions directly with instant correction',
    drawPen: 'Pen',
    highlighter: 'Highlighter',
    addNote: 'Sticky Note',
    eraser: 'Eraser',
    clearDrawing: 'Clear drawings',
    savePdf: 'Download PDF',
    openInOfficialPdfReader: 'Open in Official PDF Reader',
    officialPdfReaderTooltip: 'Open directly in your system/browser native PDF viewer',
    examYearsLabel: 'Years:',
    exportingPdf: 'Exporting PDF...',
    pdfExportSuccess: 'PDF generated successfully!',
    pdfExportError: 'Error generating PDF, please retry',
    startPracticeFromLesson: 'Start MCQs',
    drawingColor: 'Color',
    strokeSize: 'Line size',
    typeNotePlaceholder: 'Type personal clinical notes...',
    deleteNote: 'Delete note',
    selectWilaya: 'Select Wilaya',
    selectWilayaDesc: 'Choose exam source by state/wilaya or browse all',
    searchWilayaPlaceholder: 'Search wilaya...',
    allWilayas: 'All wilayas',
    selectLevel: 'Level & Faculty',
    selectLevelDesc: 'Select your medical faculty and academic year',
    textHighlight: 'Highlight text',
    removeHighlight: 'Remove highlight',
    highlightInstruction: 'Select any word to highlight it',
    studyTools: 'Study & annotation tools',
    readingMode: 'Reading mode',
    textHighlightMode: 'Word highlight',
    facultyLabel: 'Faculty',
    selectSubject: 'Select Subject',
    selectSubjectDesc: 'Choose the medical module you wish to study',
    selectLesson: 'Select Lesson',
    selectLessonDesc: 'Practice a specific topic or all questions for this subject',
    allQuestionsOfSubject: 'All questions',
    questionsCount: 'MCQs',
    questionSingular: 'MCQ',
    noSubjectsFound: 'No subjects found for this level yet',
    noLessonsFound: 'No lessons or questions found for this subject',
    changeStep: 'Change previous selection',
    theoryTitle: 'Lesson',
    theoryTooltip: 'View theory lesson notes',
    theoryClose: 'Close theory',
    fontSmaller: 'Decrease text size',
    fontLarger: 'Increase text size',
    loadingData: 'Loading data...',
    loadingQuestions: 'Loading questions...',
    loadingErrorTitle: 'Loading failed',
    loadingErrorDesc: 'Could not connect to the database. Please check your network and retry.',
    retry: 'Retry',
    backToWizard: 'Dashboard',
    questionOfTotal: 'Question {current} of {total}',
    singleChoiceOnly: 'Single choice only',
    chooseNAnswers: 'Choose {n} answers',
    validate: 'Validate',
    previous: 'Previous',
    next: 'Next',
    finish: 'Finish',
    explanation: 'Explanation',
    incorrectAnswer: 'Incorrect Answer',
    correctAnswer: 'Correct Answer',
    theCorrectAnswer: 'The Correct Answer',
    session: 'Session',
    chapter: 'Chapter',
    lesson: 'Lesson',
    allBadge: 'All',
    scoreTitle: 'Quiz Summary',
    scoreCorrect: 'Correct',
    scoreWrong: 'Wrong',
    scoreSkipped: 'Skipped',
    encouragementGreat: 'Outstanding! Excellent mastery of high-yield concepts.',
    encouragementGood: 'Good job! Keep reviewing to lock down key details.',
    encouragementNeedsWork: 'Great opportunity to revisit the theory and retry missed questions.',
    retryInOrder: 'Retry in order',
    retryShuffled: 'Retry shuffled',
    retryWrongOnly: 'Retry only my wrong answers',
    backToLessons: 'Back to lessons',
    themeLight: 'Light',
    themeCream: 'Cream',
    themeDark: 'Dark',
    years: {
      first: 'Year 1',
      second: 'Year 2',
      third: 'Year 3',
      fourth: 'Year 4',
      fifth: 'Year 5',
      sixth: 'Year 6',
    },
    mindmapMaker: 'Mindmap Maker',
    mindmapMakerDesc: 'Handcraft medical and clinical mindmaps with customizable nodes, arrow connections, and images.',
    mindmapNew: 'New Mindmap',
    mindmapAddNode: 'Add Node',
    mindmapConnect: 'Connect with Arrow',
    mindmapDeleteNode: 'Delete Node',
    mindmapDeleteEdge: 'Delete Arrow',
    mindmapShape: 'Node Shape',
    mindmapColor: 'Color',
    mindmapUploadImage: 'Upload Image',
    mindmapImageUrl: 'Image URL',
    mindmapRemoveImage: 'Remove Image',
    mindmapConnectorType: 'Connector Style',
    mindmapExportImage: 'Export PNG Image',
    mindmapExportPdf: 'Export PDF',
    mindmapExportJson: 'Backup JSON',
    mindmapImportJson: 'Import JSON',
    mindmapTemplates: 'Clinical Templates',
    mindmapSave: 'Save Map',
    mindmapSaved: 'Auto-saved',
  },
};

export const departmentOrder: Department[] = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];

export function getInitialLanguage(): Language {
  try {
    const saved = localStorage.getItem('med_mcq_lang') as Language;
    if (saved && (saved === 'ar' || saved === 'fr' || saved === 'en')) {
      return saved;
    }

    const browserLang = navigator.language.slice(0, 2).toLowerCase();
    if (browserLang === 'ar') return 'ar';
    if (browserLang === 'en') return 'en';
    return 'fr';
  } catch (e) {
    return 'fr';
  }
}

export function formatString(template: string, vars: Record<string, string | number>): string {
  return Object.entries(vars).reduce((acc, [key, val]) => {
    return acc.replace(new RegExp(`\\{${key}\\}`, 'g'), String(val));
  }, template);
}
